
import Vue from "vue";
import adminTitlingService from "@/services/admin/titlingService";
import { UserInfo } from "@/types/User";
import { debounce } from "throttle-debounce";
import { MetaNames } from "@/constants";
import AdminKennelSearchDialog from "@/components/Admin/AdminKennelSearchDialog.vue";

export default Vue.extend({
    name: "TitlingKennelReview",
    props: {
        program: String,
        propsKennelId: String
    },
    components: {
        AdminKennelSearchDialog
    },
    data: function () {
        return {
            title: MetaNames.AdminTitlingKennelReview,
            selectedProgram: this.$props.program ?? 'HOF',
            kennelId: this.$props.propsKennelId ?? null,
            search: '',
            kennelInfo: {} as any,
            sourceCertificates: [] as any[],                
            filteredSourceCertificates: [] as any[],
            hofCertificatesHeaders: [
                { text: "Dog", align: "left", value: "dogId" },
                { text: "Title", align: "left", value: "title" },
                { text: "Show Date", align: "left", value: "showDate" },
                { text: "Generated On", align: "left", value: "generatedOn" },
                { text: "Certificates", align: "left", value: "id", groupable: false },
            ],
            colors: [
                "#e51c23", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#5677fc", "#03a9f4", "#00bcd4",
                "#009688", "#259b24", "#8bc34a", "#afb42b", "#ff9800", "#ff5722", "#795548", "#607d8b",
            ],
            errorMessage: '',
            resultsSelectedForTitlePath: [] as any[],
            isLoading: false,
        };
    },        
    created() {
        if(this.$props.propsKennelId){
            if(this.$props.program){
                this.loadTitlesSelect(this.$props.program);
                } else {
                this.loadTitlesSelect('HOF');
            }
        }
    },
    methods: {
        row_classes(item: any) {
            return '';
            
        },
        getTitleColor(titleName: string, titleId: number) {
            const text = `123${titleName}123`;//`${titleId}${titleName}${titleId}`
            var hash = 0;
            if (text.length === 0) return hash;
            for (var i = 0; i < text.length; i++) {
                hash = text.charCodeAt(i) + ((hash << 3) - hash);
                hash = hash & hash;
            }
            hash = ((hash % this.colors.length) + this.colors.length) % this.colors.length;
            return this.colors[hash];
        },
        loadtitles: function (selectedProgram: string) {
            if(!selectedProgram)
                return;
            this.selectedProgram = selectedProgram;
            this.sourceCertificates = [];
            this.filteredSourceCertificates = [];
            this.filteredSourceCertificates = [];
            var calculatingCerts = true;
            var loadingResults = true;
            var loadingCerts = true;
            this.isLoading = true;
            
            adminTitlingService
                    .getSourceCerticatesForAKennel(this.kennelInfo.kennelId, this.selectedProgram)
                    .then((res: any) => {
                        
                        this.filteredSourceCertificates = [];
                        this.sourceCertificates = res;
                        this.filteredSourceCertificates = res;
                        loadingResults = false;
                        // if (!calculatingCerts && !loadingResults && !loadingCerts) {
                             this.isLoading = false;
                        // }
                    })
                    .catch((e: any) => console.log(e));
        },
        loadTitlesSelect(titleType: any) {
            this.loadtitles(titleType);                   
        },
        csvExport: function (type: number) {
            var filename = this.kennelId?.trim() + "_" + this.selectedProgram + "_certs.csv";
            var content = this.sourceCertificates;
            const keys = Object.keys(content[0]);
            const commaSeparatedString = [keys.join(","), content.map(row => keys.map(key => row[key]).join(",")).join("\n")].join("\n")
            const csvBlob = new Blob([commaSeparatedString])
            var link = document.createElement("a");
            var url = URL.createObjectURL(csvBlob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    
    },

    watch: {
        "kennelInfo.kennelId": {
            handler: debounce(
                1500,
                function(this: any, newValue, oldValue){ 
                    console.log('watch.kennelId')
                if(newValue && newValue !== oldValue && !!this.selectedProgram){
                 //   this.$router.push({ path: `/admin/titling/review/kennels/${this.selectedProgram}?kennelId=${encodeURIComponent(newValue.trim())}` }).catch(() => {});
                    this.loadTitlesSelect(this.selectedProgram);
                }
            }),
        },
        selectedProgram: {
            handler: debounce(
                1500,
                function(this: any, newValue, oldValue){ 
                    console.log('watch.selectedProgram')
                if(newValue && newValue !== oldValue && !!this.kennelInfo?.kennelId){
                   // this.$router.push({ path: `/admin/titling/review/kennels/${newValue}?kennelId=${encodeURIComponent(this.kennelId)}` }).catch(() => {});
                    this.loadTitlesSelect(newValue);
                }
            }),
        },
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
    },
});
